import { useAssetContext } from "../../../../../context/assetContext";
import { useConfigurationAssetContext } from "../../context/ConfigurationAssetContext";
import { AssetCode } from "../../models/AssetCode";

export const useAssetCodes = () => {
	const {
		state: { allAssets },
	} = useAssetContext();

	const {
		actions: { setAssetCodes },
	} = useConfigurationAssetContext();

	const buildTreeAssets = (nodes: AssetCode[]) => {
		if (nodes === undefined) return;
		//tree build functions
		const idMapping = nodes.reduce((acc: any, el: any, i: number) => {
			acc[el.id] = i;
			return acc;
		}, {});
		let root;
		nodes.forEach((el) => {
			// Handle the root element
			if (el.parentId === null) {
				root = el;
				return;
			}
			// Use our mapping to locate the parent element in our data array
			const parentEl = nodes[idMapping[el.parentId]];
			// Handle the case where the element has no parent
			if (!parentEl) {
				console.log(el);
				return;
			}
			// Add our current el to its parent's `children` array
			if (!parentEl["children"]) {
				parentEl["children"] = [];
			}
			parentEl["children"] = [...(parentEl["children"] || []), el];
		});
		setAssetCodes(root as any);
	};

	const loadFilterAssets = () => {
		const nodes = allAssets.map(
			(el) =>
				({
					id: el.AssetId,
					parentId: el.ParentAssetId,
					name: el.AssetName,
					isLeaf: !!el.IsLeaf,
					isActive: true,
					children: [],
				}) as AssetCode,
		);
		buildTreeAssets(nodes);
	};

	return { loadFilterAssets };
};
